/* ============================================
   PARFUMS DE MUSIK — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Header dark mode on hero ──
  const header = document.querySelector('.site-header');
  const hero   = document.querySelector('.hero');

  if (header && hero) {
    header.classList.add('site-header--dark');

    const obs = new IntersectionObserver(
      ([entry]) => {
        header.classList.toggle('site-header--dark', entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    obs.observe(hero);
  }

  // ── Smooth scroll for anchor links ──
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Cart count update ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const counts = document.querySelectorAll('.cart-count');
        counts.forEach(el => {
          el.textContent = cart.item_count > 0
            ? `Cart (${cart.item_count})`
            : 'Cart';
        });
      });
  }
  updateCartCount();

  // ── Add to cart ──
  document.querySelectorAll('.js-add-to-cart').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const form = this.closest('form');
      const variantId = form ? form.querySelector('[name="id"]')?.value : this.dataset.variantId;
      if (!variantId) return;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          updateCartCount();
          btn.textContent = 'Added';
          setTimeout(() => {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }, 1800);
        })
        .catch(() => {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        });
    });
  });

  // ── Product variant selector ──
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const group = this.closest('.product-form__variants');
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      // Update hidden variant input
      const form = this.closest('form');
      if (form) {
        const input = form.querySelector('[name="id"]');
        if (input) input.value = this.dataset.variantId;
      }

      // Update price display
      const price = this.dataset.price;
      const priceEl = document.querySelector('.product-price');
      if (priceEl && price) {
        priceEl.textContent = formatMoney(parseInt(price));
      }
    });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── Newsletter form ──
  document.querySelectorAll('.js-newsletter-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = this.querySelector('input[type="email"]').value;
      const btn   = this.querySelector('button[type="submit"]');
      if (!email) return;
      btn.textContent = 'Thank you';
      btn.disabled = true;
    });
  });

  // ── Scroll reveal (light fade-in on sections) ──
  const revealEls = document.querySelectorAll(
    '.statement, .brand-promise, .journal-section, .discovery-band, .collection-header'
  );

  if ('IntersectionObserver' in window) {
    const revealObs = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            revealObs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    revealEls.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
      revealObs.observe(el);
    });
  }

});
